export function debounce<T extends(...args: unknown[]) => void>(fn: T, delay = 300): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}

export function debouncePromise<Args extends unknown[], R>(fn: (...args: Args) => Promise<R>, delay = 300) {
  let timer: ReturnType<typeof setTimeout> | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let lastReject: ((reason?: any) => void) | null = null;
  return (...args: Args): Promise<R> => {
    if (timer) clearTimeout(timer);
    if (lastReject) {
      lastReject(new Error('Debounced'));
      lastReject = null;
    }
    return new Promise((resolve, reject) => {
      lastReject = reject;
      timer = setTimeout(async () => {
        try {
          const res = await fn(...args);
          resolve(res);
        } catch (e) {
          reject(e);
        } finally {
          lastReject = null;
          timer = null;
        }
      }, delay);
    });
  };
}
